import { Component } from '@angular/core';
// import { AnimationOptions } from 'ngx-lottie';
import { Location } from '@angular/common';

@Component({
  selector: 'app-not-auth',
  templateUrl: './not-auth.component.html',
  standalone: false
})
export class NotAuthComponent {
  options: any = {
    path: '/assets/js/unauthorizedaccess.json',
    loop: false
  };

  constructor(public location: Location) { }
}
